export enum FieldNames {
  ProjectType = "projectType",
  FunctionalArea = "functionalArea",
  Region = "region",
  Status = "status",
  ProductCategory = "productCategory",
  ProductLine0 = "productLine0",
  ProductLine1 = "productLine1",
  ProductLine2 = "productLine2",
  ProjectNumber = "projectNumber",
  ProjectName = "projectName",
  ProjectNameSort = "projectNameSort",
  ProjectTypeLabel = "projectTypeLabel",
  StatusLabel = "statusLabel",
  ProductCategoryLabel = "productCategoryLabel",
  Requestor = "requestor",
  RequestorFullName = "requestorFullName",
  ProjectLeaderFullName = "projectLeaderFullName",
  Description = "description",
  IntangibleAccountingStandard = "intangibleAccountingStandard",
  ProjectLeaders = "projectLeaders",
}
